import React from 'react';

const SquareAvatar = ({ image, alt = "Avatar", style, className = "", ...props }) => {
  const onErrorHandler = (e) => {
    e.target.src = "/images/defaultPlaceholder.jpg";
  };

  return (
    <img
      src={image || "/images/defaultPlaceholder.jpg"}
      onError={onErrorHandler}
      style={style}
      alt={alt}
      className={className}
      {...props}
    />
  );
};

export default SquareAvatar;
